import { h } from 'preact'
import { message } from '../../../../lib/intl/Message'
import styles from './LoadingSpinner.css'

type Props = { isLoading: boolean }

export function LoadingSpinner({ isLoading }: Props) {
  return (
    <div
      class={[styles.loadingSpinner, isLoading && styles.loadingSpinnerLoading]
        .filter(Boolean)
        .join(' ')}
      role="img"
      aria-label={message('status-laster')}
    />
  )
}
